<template>
  <DefaultModal>
    <template #header>
      <ConnectExchangesHeader
          :current-step="currentStep"
          @close="$emit('close')"
      />
    </template>

    <template #content>
      <ConnectExchangesContent
          :current-step="currentStep"
          @connection-change="connection = $event"
      />
    </template>

    <template #footer>
      <ConnectExchangesNavigation
          :has-back-navigation="hasBackNavigation"
          @next-step="moveToNextStep"
          @previous-step="moveToPreviousStep"
      />
    </template>
  </DefaultModal>
</template>

<script>
import { mapActions } from "vuex";
import { addBinanceKeys } from "@/services/account";
import DefaultModal from "@/components/ui/shared/modals/DefaultModal";
import ConnectExchangesHeader from "@/components/ui/shared/modals/connect-exchanges/ConnectExchangesHeader";
import ConnectExchangesContent from "@/components/ui/shared/modals/connect-exchanges/ConnectExchangesContent";
import ConnectExchangesNavigation from "@/components/ui/shared/modals/connect-exchanges/ConnectExchangesNavigation";

export default {
  name: "ConnectExchanges",
  components: { DefaultModal, ConnectExchangesHeader, ConnectExchangesContent, ConnectExchangesNavigation },
  data() {
    return {
      currentStep: 1,
      connection: {}
    }
  },
  computed: {
    hasBackNavigation() {
      return this.currentStep !== 1
    },
    isLastStep() {
      return this.currentStep === 3
    }
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading',
      setSnackbarError: 'setSnackbarError',
      setBinanceKeys: 'setBinanceKeys'
    }),
    moveToNextStep() {
      if (this.isLastStep) {
        this.setIsLoading(true)
        addBinanceKeys(this.connection)
            .then(({ data }) => {
              this.setBinanceKeys(data)
              setTimeout(() => {
                this.$emit('close')
              }, 400)
            })
            .catch(({ message }) => this.setSnackbarError(message))
            .finally(() => this.setIsLoading(false))
      }
      this.currentStep++
    },
    moveToPreviousStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>